{
  "version": "1.0.0",
  "categories": {
    "primarySpaceHeating": [
      {
        "when": {
          "climateZone": "1",
          "primarySpaceHeatingCooling": "Elec Heat Pump w/ Elec Furnace"
        },
        "points": 9
      },
      {
        "when": {
          "climateZone": "1",
          "primarySpaceHeatingCooling": "Gas ≥ 95 AFUE"
        },
        "points": 2.5
      },
      {
        "when": {
          "climateZone": "2",
          "primarySpaceHeatingCooling": "Elec Heat Pump w/ Elec Furnace"
        },
        "points": 13.5
      },
      {
        "when": {
          "climateZone": "2",
          "primarySpaceHeatingCooling": "Gas ≥ 95 AFUE"
        },
        "points": 3.5
      },
      {
        "when": {
          "climateZone": "3",
          "primarySpaceHeatingCooling": "Elec Heat Pump w/ Elec Furnace"
        },
        "points": 17
      },
      {
        "when": {
          "climateZone": "3",
          "primarySpaceHeatingCooling": "Gas ≥ 95 AFUE"
        },
        "points": 7.5
      }
    ],
    "envelope": [
      {
        "when": {
          "climateZone": "1",
          "envelope": "Exhibit 1 ONLY"
        },
        "points": 7.5
      },
      {
        "when": {
          "climateZone": "2",
          "envelope": "Exhibit 1 ONLY"
        },
        "points": 2.5
      },
      {
        "when": {
          "climateZone": "3",
          "envelope": "Exhibit 1 ONLY"
        },
        "points": 2
      },
      {
        "when": {
          "climateZone": "1",
          "envelope": "Exhibit 1 and Uo ≤ 0.049"
        },
        "points": 19.5
      },
      {
        "when": {
          "climateZone": "2",
          "envelope": "Exhibit 1 and Uo ≤ 0.049"
        },
        "points": 12
      },
      {
        "when": {
          "climateZone": "3",
          "envelope": "Exhibit 1 and Uo ≤ 0.049"
        },
        "points": 6.5
      }
    ],
    "lighting": [
      {
        "when": {
          "lighting": "All LED"
        },
        "points": 0.5
      }
    ],
    "appliances": [
      {
        "when": {
          "appliances": "Energy Star Refrigerator & Dishwasher"
        },
        "points": 0.5
      }
    ],
    "estarClothesWasher": [
      {
        "when": {
          "estarClothesWasher": "EStar Clothes Washer"
        },
        "points": 0.5
      }
    ],
    "bathroomWaterFixtures": [
      {
        "when": {
          "bathroomWaterFixtures": "Bathroom faucets ≤ 1.5 gallons per minute (gpm) & showerheads ≤ 2.0 gpm"
        },
        "points": 0.5
      }
    ],
    "waterHeating": [
      {
        "when": {
          "climateZone": "1",
          "primarySpaceHeatingCooling": [
            "Elec Heat Pump w/ Elec Furnace",
            "Gas ≥ 95 AFUE"
          ],
          "waterHeating": "HP/WH ≥ 3.30 UEF"
        },
        "points": 11.5
      },
      {
        "when": {
          "climateZone": "2",
          "primarySpaceHeatingCooling": [
            "Elec Heat Pump w/ Elec Furnace",
            "Gas ≥ 95 AFUE"
          ],
          "waterHeating": "HP/WH ≥ 3.30 UEF"
        },
        "points": 13
      },
      {
        "when": {
          "climateZone": "3",
          "primarySpaceHeatingCooling": [
            "Elec Heat Pump w/ Elec Furnace",
            "Gas ≥ 95 AFUE"
          ],
          "waterHeating": "HP/WH ≥ 3.30 UEF"
        },
        "points": 9
      },
      {
        "when": {
          "climateZone": "1",
          "primarySpaceHeatingCooling": "Elec Resistance Furnace Only",
          "waterHeating": "HP/WH ≥ 3.30 UEF"
        },
        "points": 7.5
      },
      {
        "when": {
          "climateZone": "2",
          "primarySpaceHeatingCooling": "Elec Resistance Furnace Only",
          "waterHeating": "HP/WH ≥ 3.30 UEF"
        },
        "points": 7
      },
      {
        "when": {
          "climateZone": "3",
          "primarySpaceHeatingCooling": "Elec Resistance Furnace Only",
          "waterHeating": "HP/WH ≥ 3.30 UEF"
        },
        "points": 1.5
      }
    ]
  }
}
